/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FreelancerSignupAccountDraft
 */
export interface FreelancerSignupAccountDraft {
    /**
     * 
     * @type {string}
     * @memberof FreelancerSignupAccountDraft
     */
    firstName?: string;
    /**
     * 
     * @type {string}
     * @memberof FreelancerSignupAccountDraft
     */
    lastName?: string;
    /**
     * 
     * @type {string}
     * @memberof FreelancerSignupAccountDraft
     */
    email: string;
    /**
     * 
     * @type {boolean}
     * @memberof FreelancerSignupAccountDraft
     */
    areTermsAndConditionsAccepted: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FreelancerSignupAccountDraft
     */
    isOptedInToMarketingEmails: boolean;
}

/**
 * Check if a given object implements the FreelancerSignupAccountDraft interface.
 */
export function instanceOfFreelancerSignupAccountDraft(value: object): value is FreelancerSignupAccountDraft {
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('areTermsAndConditionsAccepted' in value) || value['areTermsAndConditionsAccepted'] === undefined) return false;
    if (!('isOptedInToMarketingEmails' in value) || value['isOptedInToMarketingEmails'] === undefined) return false;
    return true;
}

export function FreelancerSignupAccountDraftFromJSON(json: any): FreelancerSignupAccountDraft {
    return FreelancerSignupAccountDraftFromJSONTyped(json, false);
}

export function FreelancerSignupAccountDraftFromJSONTyped(json: any, ignoreDiscriminator: boolean): FreelancerSignupAccountDraft {
    if (json == null) {
        return json;
    }
    return {
        
        'firstName': json['firstName'] == null ? undefined : json['firstName'],
        'lastName': json['lastName'] == null ? undefined : json['lastName'],
        'email': json['email'],
        'areTermsAndConditionsAccepted': json['areTermsAndConditionsAccepted'],
        'isOptedInToMarketingEmails': json['isOptedInToMarketingEmails'],
    };
}

export function FreelancerSignupAccountDraftToJSON(value?: FreelancerSignupAccountDraft | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'email': value['email'],
        'areTermsAndConditionsAccepted': value['areTermsAndConditionsAccepted'],
        'isOptedInToMarketingEmails': value['isOptedInToMarketingEmails'],
    };
}

